// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTimeCircle2OutlinedSvg from "@fishx/icons-svg/es/asn/PTimeCircle2Outlined";
import FishxIcon from '../components/FishxIcon';

var PTimeCircle2Outlined = function PTimeCircle2Outlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTimeCircle2OutlinedSvg
  }));
};

PTimeCircle2Outlined.displayName = 'PTimeCircle2Outlined';
export default React.forwardRef(PTimeCircle2Outlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTimeCircle2Outlined.js
// module id = 3681
// module chunks = 0